import { PROPERTY_CALLOUT_BADGE_ID, RESULTS_PAGE_SIZE, } from '@awaze/mfe-common.api.site-search-service';
import { formatDataLayerString, generateDataLayerFacetSelection, getISODate, } from '../../DataLayerUtils';
export const generateSearchDataLayerProductList = ({ page, size, properties, accommodationType = 'cottages', site, propertyCode, }) => {
    const mapping = {
        product_parent_id: [],
        product_parent_name: [],
        product_parent_brand: [],
        product_parent_review_score: [],
        product_parent_location: [],
        product_parent_location_category: [],
        product_sku: [],
        product_name: [],
        product_type: [],
        product_grade: [],
        product_capactiy: [],
        product_bedrooms: [],
        product_bathrooms: [],
        product_pets: [],
        product_key_features: [],
        product_list_availability: [],
        product_list_position: [],
        product_list_price: [],
        product_list_strikethrough_price: [],
        product_list_badge: [],
        product_is_free_cancellation: [],
        product_review_score: [],
    };
    if (properties && properties.length > 0) {
        const clickedProperty = propertyCode
            ? properties.find((property) => property.code === propertyCode)
            : null;
        const renderedProperties = clickedProperty ? [clickedProperty] : properties;
        renderedProperties.forEach((property, index) => {
            const propertyPosition = clickedProperty
                ? properties.indexOf(clickedProperty)
                : index;
            const propertyListPosition = ((page - 1) * size +
                (propertyPosition + 1))?.toString();
            const features = property.features || [];
            const availability = property.startDate
                ? [{ startDate: property.startDate, price: property.price }]
                : [];
            const isCustomerChoice = property.features?.some(({ featureId }) => featureId === PROPERTY_CALLOUT_BADGE_ID) || false;
            const productParentId = site?.code || property.code || '';
            const productParentName = site?.displayName || property.displayName || '';
            /* eslint-disable no-nested-ternary */
            const productSku = accommodationType === 'cottages'
                ? property.code || ''
                : site
                    ? property.code
                    : '';
            /* eslint-enable */
            const propertyDisplayName = property.displayName || '';
            const bedroomCount = property.property?.bedrooms || '';
            const petCount = property.property?.pets || '';
            const sleeps = property.property?.sleeps || '';
            const bathroomCount = property.property?.bathrooms || '';
            const grade = property.grade || '';
            const averageReviewScore = property.averageReviewScore || '';
            const wasPrice = property.wasPrice || '';
            const productParentLocationCategory = property.rhs3 || '';
            const productParentLocation = property.location || '';
            const displayedPrice = property.price || property.priceFrom || '';
            const propertyFeaturesFormatted = features
                ? features
                    .map((feature) => formatDataLayerString(feature.featureName))
                    .join(',')
                : '';
            const propertyListAvailability = availability.length > 0 ? availability?.length?.toString() : '';
            const propertyListBadge = isCustomerChoice ? 'is customer choice' : '';
            mapping.product_parent_id.push(productParentId);
            mapping.product_parent_name.push(formatDataLayerString(productParentName));
            mapping.product_parent_brand.push('');
            mapping.product_parent_review_score.push('');
            mapping.product_parent_location.push(formatDataLayerString(productParentLocation));
            mapping.product_parent_location_category.push(formatDataLayerString(productParentLocationCategory));
            mapping.product_sku.push(productSku);
            mapping.product_name.push(formatDataLayerString(propertyDisplayName));
            mapping.product_type.push(formatDataLayerString(''));
            mapping.product_grade.push(formatDataLayerString(grade));
            mapping.product_capactiy.push(formatDataLayerString(sleeps?.toString()));
            mapping.product_bedrooms.push(formatDataLayerString(bedroomCount?.toString()));
            mapping.product_bathrooms.push(formatDataLayerString(bathroomCount?.toString()));
            mapping.product_pets.push(formatDataLayerString(petCount?.toString()));
            mapping.product_key_features.push(propertyFeaturesFormatted);
            mapping.product_list_availability.push(propertyListAvailability);
            mapping.product_list_position.push(propertyListPosition);
            mapping.product_list_price.push(displayedPrice?.toString());
            mapping.product_list_strikethrough_price.push(wasPrice?.toString());
            mapping.product_list_badge.push(propertyListBadge);
            mapping.product_is_free_cancellation.push('');
            mapping.product_review_score.push(formatDataLayerString(averageReviewScore?.toString()));
        });
    }
    return mapping;
};
export const buildDataLayerProductList = ({ searchCriteria, searchData, propertyCode, }) => generateSearchDataLayerProductList({
    page: searchCriteria?.page ?? 1,
    size: searchCriteria?.size ?? RESULTS_PAGE_SIZE,
    properties: searchData?.properties,
    site: searchData?.site,
    accommodationType: searchCriteria.accommodationType,
    propertyCode,
});
const getDataLayerProductListMapping = ({ supplierCode, supplierName, productParentLocation, productParentLocationCategory, productParentReviewScore, id, propertyDisplayName, productType, grade, sleeps, bedroomCount, bathroomCount, petCount, propertyFeaturesFormatted, displayedPrice, }) => ({
    product_parent_id: [supplierCode],
    product_parent_name: [formatDataLayerString(supplierName)],
    product_parent_brand: [''],
    product_parent_location: [formatDataLayerString(productParentLocation)],
    product_parent_location_category: [
        formatDataLayerString(productParentLocationCategory),
    ],
    product_parent_review_score: [
        formatDataLayerString(productParentReviewScore.toString()),
    ],
    product_sku: [id],
    product_name: [formatDataLayerString(propertyDisplayName)],
    product_type: [formatDataLayerString(productType)],
    product_grade: [formatDataLayerString(grade)],
    product_capacity: [formatDataLayerString(sleeps.toString())],
    product_bedrooms: [formatDataLayerString(bedroomCount.toString())],
    product_bathrooms: [formatDataLayerString(bathroomCount.toString())],
    product_pets: [formatDataLayerString(petCount.toString())],
    product_key_features: [propertyFeaturesFormatted],
    product_is_free_cancellation: [''],
    product_price: [displayedPrice],
});
export const generateDataLayerProductList = ({ propertyData, price, }) => {
    const propertyDataNotSet = propertyData === undefined;
    if (propertyDataNotSet) {
        return getDataLayerProductListMapping({
            supplierCode: '',
            supplierName: '',
            productParentLocation: '',
            productParentLocationCategory: '',
            productParentReviewScore: '',
            id: '',
            propertyDisplayName: '',
            productType: '',
            grade: '',
            sleeps: '',
            bedroomCount: '',
            bathroomCount: '',
            petCount: '',
            propertyFeaturesFormatted: '',
            displayedPrice: '',
        });
    }
    const features = propertyData.features || [];
    const supplierCode = propertyData.supplierCode || '';
    const supplierName = propertyData.siteName || '';
    const id = propertyData.code || '';
    const propertyDisplayName = propertyData.propertyName || '';
    const productType = propertyData.propertyType || '';
    const bedroomCount = propertyData.specs.bedrooms;
    const petCount = propertyData.specs.pets;
    const { sleeps } = propertyData.specs;
    const bathroomCount = propertyData.specs.bathrooms;
    const grade = propertyData.grade || '';
    const productParentReviewScore = propertyData.review?.averageReviewScore || '';
    const productParentLocationCategory = ''; // this is rhs3 data in search mfe which we lack here
    const productParentLocation = propertyData.location ?? ''; // using current property until we support multi unit sites
    const displayedPrice = price !== undefined ? price.toString() : '';
    const propertyFeaturesFormatted = features
        ? features.map((feature) => formatDataLayerString(feature.name)).join(',')
        : '';
    return getDataLayerProductListMapping({
        supplierCode,
        supplierName,
        productParentLocation,
        productParentLocationCategory,
        productParentReviewScore,
        id,
        propertyDisplayName,
        productType,
        grade,
        sleeps,
        bedroomCount,
        bathroomCount,
        petCount,
        propertyFeaturesFormatted,
        displayedPrice,
    });
};
export const generateDataLayerSiteProductList = ({ siteData, }) => {
    const features = siteData.features || [];
    const supplierCode = siteData.code || '';
    const supplierName = siteData.siteName || '';
    const id = siteData.code || '';
    const propertyDisplayName = siteData.siteName || '';
    const productType = '';
    const bedroomCount = '';
    const petCount = '';
    const sleeps = '';
    const bathroomCount = '';
    const grade = '';
    const productParentReviewScore = siteData.review?.averageReviewScore || '';
    const productParentLocationCategory = ''; // this is rhs3 data in search mfe which we lack for sites
    const productParentLocation = siteData.location || '';
    const displayedPrice = '';
    const propertyFeaturesFormatted = features
        ? features.map((feature) => formatDataLayerString(feature.name)).join(',')
        : '';
    return getDataLayerProductListMapping({
        supplierCode,
        supplierName,
        productParentLocation,
        productParentLocationCategory,
        productParentReviewScore,
        id,
        propertyDisplayName,
        productType,
        grade,
        sleeps,
        bedroomCount,
        bathroomCount,
        petCount,
        propertyFeaturesFormatted,
        displayedPrice,
    });
};
export const generateDataLayerAvailability = ({ availabilityData, }) => {
    return {
        availability_adults: availabilityData.adults,
        availability_children: availabilityData.children,
        availability_infants: availabilityData.infants,
        availability_start_date: getISODate(availabilityData.startDate),
        availability_duration: availabilityData.duration,
        availability_pets: availabilityData.pets,
    };
};
export const generateDataLayerShopList = ({ aggregations, bathrooms, bedrooms, features, grade, rating, sort, }) => ({
    shop_list_sort: sort ? formatDataLayerString(sort) : '',
    shop_list_facet_selection: aggregations
        ? generateDataLayerFacetSelection({
            aggregations,
            bathrooms,
            bedrooms,
            features,
            grade,
            rating,
        })
        : '',
});
export const mapSiteResponseToCommonSite = (siteResponse) => ({
    code: siteResponse.code,
    displayName: siteResponse.siteName,
});
//# sourceMappingURL=PDPDataLayerUtils.js.map